/* global Sys, Core, Resources */
Sys.ns("Core.gameAdapterApi");

Core.gameAdapterApi.messageActions = {
    GAME_ADAPTER_API_TOPIC: "game-adapter-api",
    CALL: {
        RESOLVE_DIALOG: "resolveDialog",
        RESUME: "resume",
        UPDATE_BALANCE_ID: "updateBalanceId",
        UPDATE_PLAY_MODE: "updatePlayMode",
        UPDATE_SG_STATUS: "updateSpinGiftsStatus",
        UPDATE_BALANCE: "updateBalance",
        UPDATE_FREE_ROUNDS: "updateFreeRounds",
        UPDATE_PROMOTIONS_BALANCE: "updatePromotionsBalance",
        UPDATE_PROMOTIONS_TOTAL_WIN: "updatePromotionsTotalWin"
    },
    ACTION_STATUS: {
        ILLEGAL_ARGUMENT: 1,
        FUNCTIONALITY_NOT_AVAILABLE: 9,
        WRONG_NUMBER_OF_ARGUMENTS: 10,
        CALL_EXECUTION_ERROR: 23,
        OK: 127
    },

    createResolveUpdateBalanceIdCall: function() {
        var me = this;

        return {
            id: me.CALL.UPDATE_BALANCE_ID,

            act: function(params) {
                window.Services.integration.handleBalanceIdUpdate(params.balanceId);
            },

            validate: function(params) {
                return params && Sys.isString(params.balanceId) ? me.ACTION_STATUS.OK : me.ACTION_STATUS.ILLEGAL_ARGUMENT;
            }
        };
    },

    createResolveUpdatePlayModeCall: function() {
        var me = this;

        return {
            id: me.CALL.UPDATE_PLAY_MODE,

            act: function(params) {
                window.Services.integration.handlePlayModeUpdate(params.newPlayMode, params.prevPlayMode);
            },

            validate: function(params) {
                return params && Sys.isString(params.newPlayMode) && Sys.isString(params.prevPlayMode) ? me.ACTION_STATUS.OK : me.ACTION_STATUS.ILLEGAL_ARGUMENT;
            }
        };
    },

    createResolveUpdateSpinGiftsStatusCall: function() {
        var me = this;

        return {
            id: me.CALL.UPDATE_SG_STATUS,

            act: function(params) {
                window.Services.integration.handleSpinGiftsStatusUpdate(params.status);
            },

            validate: function(params) {
                return params && Sys.isString(params.status) ? me.ACTION_STATUS.OK : me.ACTION_STATUS.ILLEGAL_ARGUMENT;
            }
        };
    },

    // CALLS ->
    createResolveDialogCall: function(store) {
        var me = this;

        return {
            id: me.CALL.RESOLVE_DIALOG,

            act: function(params) {
                var buttonAction = store.getButtonAction(params.buttonId);

                store.releaseBlocker();

                if (Sys.isFunc(buttonAction)) {
                    buttonAction();
                }
            },

            validate: function(params) {
                var status = me.ACTION_STATUS.ILLEGAL_ARGUMENT;

                if (params && Sys.isNumber(params.reason) && Sys.isNumber(params.buttonId)) {
                    status = me.ACTION_STATUS.OK;
                }

                return status;
            }
        };
    },

    createResumeCall: function(store) {
        var me = this;

        return {
            id: me.CALL.RESUME,

            act: function() {
                store.releaseBlocker();
            },

            validate: function() {
                return me.ACTION_STATUS.OK;
            }
        };
    },

    createUpdateBalanceCall: function(store, observable) {
        var me = this;

        return {
            id: me.CALL.UPDATE_BALANCE,

            act: function(params) {
                observable.fireEvent("request:moneyManager.agUpdateBalance", Math.round(params.balance * 100));
            },

            validate: function(params) {
                return params && Sys.isNumber(params.balance) ?
                    me.ACTION_STATUS.OK :
                    me.ACTION_STATUS.ILLEGAL_ARGUMENT;
            }
        };
    },

    createUpdateFreeRoundsCall: function(store, observable) {
        var me = this;

        return {
            id: me.CALL.UPDATE_FREE_ROUNDS,

            act: function(params) {
                if (params.roundsLeft) {
                    observable.fireEvent("request:freeRounds.agSetFreeRoundsLeft", parseInt(params.roundsLeft, 10));
                }
                if (params.totalWin) {
                    observable.fireEvent("request:freeRounds.agSetFreeRoundsTotalWin", Math.round(parseFloat(params.totalWin) * 100));
                }
                Resources.storeData("isAgFreeRoundsActive", true);
            },

            validate: function(params) {
                return params &&
                    Sys.isNumber(params.roundsLeft) &&
                    Sys.isNumber(params.totalWin) ?
                    me.ACTION_STATUS.OK :
                    me.ACTION_STATUS.ILLEGAL_ARGUMENT;
            }
        };
    },

    createUpdatePromotionsBalanceCall: function(store, observable) {
        var me = this;

        return {
            id: me.CALL.UPDATE_PROMOTIONS_BALANCE,

            act: function(params) {
                observable.fireEvent("request:freeRounds.agSetFreeRoundsLeft", parseInt(params.promoBalance, 10));
                Resources.storeData("isAgFreeRoundsActive", parseInt(params.promoBalance, 10) > 0);
            },

            validate: function(params) {
                return params && Sys.isNumber(params.promoBalance) ?
                    me.ACTION_STATUS.OK :
                    me.ACTION_STATUS.ILLEGAL_ARGUMENT;
            }
        };
    },

    createUpdatePromotionsTotalWinCall: function(store, observable) {
        var me = this;

        return {
            id: me.CALL.UPDATE_PROMOTIONS_TOTAL_WIN,

            act: function(params) {
                observable.fireEvent("request:freeRounds.agSetFreeRoundsTotalWin", Math.round(parseFloat(params.promoTotalWin) * 100));
            },

            validate: function(params) {
                return params && Sys.isNumber(params.promoTotalWin) ?
                    me.ACTION_STATUS.OK :
                    me.ACTION_STATUS.ILLEGAL_ARGUMENT;
            }
        };
    },
    // <- CALLS
    // HANDLE API CALL ->
    getRequestedAction: function(actionName, actionsMap) {
        var action = actionsMap[actionName];

        return action || null;
    },

    validateRequestedAction: function(action, params) {
        // validate action exists in registry
        if (!action) {
            return this.ACTION_STATUS.FUNCTIONALITY_NOT_AVAILABLE;
        }

        // validate action params
        if (action.validate && Sys.isFunc(action.validate)) {
            return action.validate(params);
        }

        return this.ACTION_STATUS.OK;
    },

    handleApiCall: function(actionsMap, messagePayload, messageApi) {
        var requestedAction = this.getRequestedAction(messagePayload.call, actionsMap),
            actionStatus = this.validateRequestedAction(requestedAction, messagePayload.params),
            callResult;

        // send error message if validation didn't succeed
        if (actionStatus !== this.ACTION_STATUS.OK) {
            messageApi.sendResultEvent({
                result: "error",
                id: messagePayload.id,
                data: {
                    code: actionStatus,
                    message: "validation failed"
                }
            });

            return;
        }

        try {
            callResult = requestedAction.act(messagePayload.params);

            messageApi.sendResultEvent({ result: "success", id: messagePayload.id, data: callResult });
        }
        catch (e) {
            messageApi.sendResultEvent({
                result: "error",
                id: messagePayload.id,
                data: {
                    code: this.ACTION_STATUS.CALL_EXECUTION_ERROR,
                    message: e.message || "call execution error"
                }
            });
        }
    },
    // <- HANDLE API CALL
    // INIT ->
    createMessageCallHandler: function(actionsMap, messageApi) {
        var me = this;

        return function(event) {
            var messagePayload;

            if (event.data && event.data.topic === me.GAME_ADAPTER_API_TOPIC) {
                messagePayload = event.data.payload;

                if (messagePayload === undefined) {
                    console.error("No 'payload' was found in the message");
                    return;
                }

                if (messagePayload.id === undefined) {
                    console.error("No 'id' property was found in the message", messagePayload);
                    return;
                }

                if (messagePayload.call) {
                    me.handleApiCall(actionsMap, messagePayload, messageApi);
                }
            }
        };
    },

    buildActionsMap: function(store, observable) {
        return {
            resume: this.createResumeCall(store),
            resolveDialog: this.createResolveDialogCall(store),
            updateBalanceId: this.createResolveUpdateBalanceIdCall(),
            updatePlayMode: this.createResolveUpdatePlayModeCall(),
            updateSpinGiftsStatus: this.createResolveUpdateSpinGiftsStatusCall(),
            updateBalance: this.createUpdateBalanceCall(store, observable),
            updateFreeRounds: this.createUpdateFreeRoundsCall(store, observable),
            updatePromotionsBalance: this.createUpdatePromotionsBalanceCall(store, observable),
            updatePromotionsTotalWin: this.createUpdatePromotionsTotalWinCall(store, observable)
        };
    },

    init: function(store, messageApi) {
        var observable = new window.Sys.Observable(),
            actionsMap = this.buildActionsMap(store, observable);

        window.addEventListener(
            "message",
            this.createMessageCallHandler(actionsMap, messageApi)
        );
    }
    // <- INIT
};
